export default __webpack_public_path__ + "static/media/edit@1x.aa374897.svg";